import { supabase } from '../supabaseClient';
import { ADMIN_2FA_HEADER } from '../shared/adminEmail2fa';
import { getApiUrl } from './platform';
import { supportSessionHeader } from './supportSession';
import {
  adminEmailSessionHeader,
  clearAdminEmailToken,
  noteAdminEmailStatus,
} from './adminEmailSession';

export async function agentAuthHeaders(extra = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const headers = { 'Content-Type': 'application/json', ...supportSessionHeader(), ...extra };
  if (session?.access_token) {
    headers.Authorization = `Bearer ${session.access_token}`;
  }
  return headers;
}

export async function adminSessionFetch(path, body) {
  const response = await fetch(getApiUrl(path), {
    method: 'POST',
    headers: await agentAuthHeaders(adminEmailSessionHeader()),
    credentials: 'include',
    body: JSON.stringify(body == null ? {} : body),
  });
  noteAdminEmailStatus(response.status);
  return response;
}

export async function endAdminEmailSession() {
  if (adminEmailSessionHeader()[ADMIN_2FA_HEADER]) {
    try {
      await adminSessionFetch('/.netlify/functions/admin-email-2fa', { action: 'clear' });
    } catch (error) {
      // The saved token is still removed below.
    }
  }
  clearAdminEmailToken();
}

export async function agentPost(path, body) {
  const response = await fetch(getApiUrl(path), {
    method: 'POST',
    headers: await agentAuthHeaders(),
    body: JSON.stringify(body == null ? {} : body),
  });
  const data = await response.json().catch(() => ({}));
  return {
    ok: response.ok,
    status: response.status,
    error: (data && (data.error || data.message)) || '',
    data,
  };
}
